export const hProps = { height: "100%" }
